import script from "./BaseProductCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseProductCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseProductCard.vue?vue&type=style&index=0&id=0e08d6b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e08d6b6"]])

export default __exports__